import React from 'react'

import { HelpCenterListType, HelpCenterType } from '@application/Types/ComponentTypes'

import { HelpCenterListView } from './HelpCenterListView'
import { HelpCenterMainView } from './HelpCenterMainView'

export const isListView = (props: HelpCenterType): props is HelpCenterListType => 'items' in props

export const HelpCenterList = (props: HelpCenterType): JSX.Element => {
    if (isListView(props)) {
        return <HelpCenterListView {...props} />
    } else {
        return <HelpCenterMainView {...props} />
    }
}
